import http from '@/utils/http'
import { networkData } from '@/utils/data'

/**基础数据**/
//学校管理
export const querySchool = (params) => http.post('/marking-user/user/school/query_school', params)
export const queryListGrade = (params) => http.get('/marking-platform/school/grade/school-id/academic-year', params)
// 五四制新增年级结构
export const getGradeList = (params) => http.get('/marking-user/user/school/query_school_grade', params)

// 获取学校信息
export const getSchool = id => http.get('/marking-platform/school/' + id, {})
export const getTeacher = (params) => {
  // 启用、非精确匹配
  params.userStatus = 1
  params.exactMatch = false
  return http.post('/marking-platform/teachers/search/simple', params)
}

// 获取年级信息
export const getGradeInfo = (gradeId) => http.get(`/marking-platform/school/grade/${gradeId}`)

//班级管理

export const getGradeClassList = (params) => http.post('/marking-platform/school-class/grade-class', params)	// 获取所以班级列表
export const getTeachClassList = (params) => http.post('/marking-platform/school-class/teach-class', params)	// 获取所以班级列表

//学生管理
export const queryStudent = (params) => http.get('/marking-user/user/student/get_stu', params)
export const setStudStatistics = (params) => http.put('/marking-platform/students/statistic', params, 'form')
export const exportStudentQR = (params) => http.post(`/marking-platform/task/student-qr/schools/${params.schoolId}`, params.classIds)
export const getStudentList = (params) => http.post('/marking-platform/students/search', params) //查询学生选科信息

// 刷新报告
export const refreshReport = (params) => http.post('/marking-main/exam/exam/refresh_report', params) // 刷新报告,

// 首页
export const getAuthGradeList = (params) => http.get('/marking-platform/school/grade/school-id/academic-year/personal', params, 'form') // 查询权限年级
export const getAuthClassList = (params) => http.get(`marking-platform/school-class/grade-class/gradeId/${params.gradeId}/personal`, 'form') // 查询权限班级
export const getAuthSubjectList = (params) => http.expired('/marking-user/user/school/get_perm_subject', params, 'form') // 查询权限学科


//大数据中心(命名不好，为根据用户权限获取对应年级、班级、学生列表)
export const getBigDataGrade = (params) => http.post('/marking-user/student/tracker/query/grade', params, 'form')//查询该用户权限下的年级
export const getBigDataClass = (params) => http.post('/marking-user/student/tracker/query/class', params, 'form')//查询该用户权限下的班级
export const getBigDataStudent = (params) => http.post('/marking-user/student/tracker/query/student', params, 'form')//查询该用户权限下的学生
export const queryClassById = (params) => http.post('/marking-user/user/school/query/class', params)//查询班级信息

//根据学科获取题型
export const getPatternByCode = (params) => http.get('/marking-report/bigdata/list/pattern', params)//根据学科获取题型

// 分层走班
export const getTeachers = (params) => http.post('/marking-platform/teachers/search/simple/page', params) // 查询老师

// 题库
export const getSchoolGradeList = (params) => http.get('/marking-platform/school/grade/school-id/academic-year', params, 'form') 	// 根据学校获取年级
export const getSchoolClassList = (params) => http.get(`marking-platform/school-class/grade-class/gradeId/${params.gradeId}`, 'form') 	// 根据年级获取班级

// 教师档案教师列表
export const getArchivesTeacherList = (params) => http.post('/marking-platform/teachers/search/teacher-more-info/page', params)


// 教师档案 v2
export const getTeacherAcademic = (id) => http.get('/marking-platform/teachers/search/history/' + id, {}) 	//教师记学年
export const getTeacherRecord = (params) => http.get(`/marking-platform/teachers/search/teaching-trail/${params.userId}/year/${params.academicYear}`, {}) 	//教师记录
export const getTeacherDetail = (id) => http.get('/marking-platform/teachers/search/teacher-more-info/' + id, {}) // 获取教师详情


// 阿里云文件上传 token
export const getAliOssToken = params => http.get("/marking-platform/ossUpload/get/fly/sts/token", params).then(resp => {
  return resp.body
});
export const word2html = params => http.post("/marking-platform/ossUpload/word2html", params);
export const pdf2html = params => http.post("/marking-platform/ossUpload/upload/file/new", params);
export const updateStudentAnswer = params => http.post("/marking-main/exam/exam/resetExamResultDetailAnswer", params, 'form');
export const getFileResourceId = params => http.post('/marking-question/public/image/question/listByOfficeUrl', params, 'form');

// 上传日志
export const commitUploadLog = (params) => http.post('/marking-minipro/online-exam/student/record/error_log', params)	//  上传失败日志

export const configApi = {
  // 根据学校，学段获取科目
  getStageSubjects: (schoolId, stage) => http.get(`/marking-platform/configurations/schools/${schoolId}/stages/${stage}/subjects`),
  // 根据学校，年级获取科目
  getGradeSubjects: params => http.post(`/marking-platform/configurations/schools/subjects/list`, params),
  // 获取其他配置
  getOther: (schoolId) => http.get(`/marking-platform/configurations/schools/${schoolId}/platformTypes/SCHOOL/others`).then(resp => {
    setConfigOptions(resp)
    return resp
  }),
  // 更新参数数值
  update: params => http.put(`/marking-platform/configurations/values`, params),

  // 初始化学校的配置
  initSchool: schoolId => http.post(`/marking-platform/configurations/schools/${schoolId}`),
  // 根据类型列表获取配置详情
  getConfigByTypes: (schoolId, types) => http.post(`/marking-platform/configurations/schools/${schoolId}/configTypes`, types).then(resp => {
    setConfigOptions(resp)
    return resp
  }),
  // 获取班级报告里年级信息里的配置情况
  getClassReportGradeData: schoolId => http.get(`/marking-platform/configurations/schools/${schoolId}/class-report-grade-data`).then(resp => {
    setConfigOptions(resp)
    return resp
  }),
}

export const getSubjectList = (params, isFilter = false) => {
  // 新接口数据，转换成 旧接口的数据格式
  return configApi.getGradeSubjects(params).then(resp => {
    if (resp.body) {
      return networkData.getTodoSubjects(resp.body, isFilter)
    }
    return resp
  })
}

export const getExamSubjectList = (params) => {
  // 新接口数据，转换成 旧接口的数据格式
  return configApi.getGradeSubjects(params).then(resp => {
    if (resp.body) {
      resp.code = 200
      resp.result = { main: [] }
      for (let index = 0; index < resp.body.length; index++) {
        const element = resp.body[index];
        resp.result.main.push({
          dicCode: element.id + '',
          dicName: element.shortName
        })
      }
    }
    return resp
  })
}

export const queryTeacherSubject = (params) => {
  // 新接口数据，转换成 旧接口的数据格式
  return configApi.getGradeSubjects(params).then(resp => {
    if (resp.body) {
      resp.code = 200
      resp.data = { obj: [] }
      for (let index = 0; index < resp.body.length; index++) {
        const element = resp.body[index];
        resp.data.obj.push({
          id: element.id,
          subjectCode: element.id,
          subjectName: element.shortName
        })
      }
    }
    return resp
  })
}

function setConfigOptions (resp) {
  if (!resp.body) return resp
  for (let index = 0; index < resp.body.length; index++) {
    const item = resp.body[index];
    item.configDescOptions = []
    const desc = item.configTypeDesc ? item.configTypeDesc : ''
    if (desc && desc.indexOf('$') === -1) continue
    // 配置规则的选项解析
    const list = desc.split('$')
    for (let cIndex = 0; cIndex < list.length; cIndex++) {
      const element = list[cIndex];
      const infos = element.split('-')
      if (infos.length <= 1) continue
      item.configDescOptions.push({
        name: infos[1],
        value: infos[0]
      })
    }
  }
}

// 根据json地址获取数据
export const getJsonDataByUrl = (url) => http.get(url)
